import React, {Fragment, useEffect} from 'react';

import '../../App.css';
import {useNavigate, useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {Button, Flex, Modal, Space, Tooltip} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleLeft, faPencil, faArrowLeft, faArrowRight, faTrash, faCopy} from "@fortawesome/free-solid-svg-icons";
import {AddShotModal} from "./AddShotModal";
import {Status} from "../../feature/project/status";
import {deleteShot, duplicateShot, fetchShot, fetchShots, saveShot} from "../../feature/project/shotSlice";
import {ShotEditor} from "./editor/ShotEditor";
import {Shot} from "../../feature/project/Shot";
import {fetchConfigChoice, fetchConfigNarration} from "../../feature/project/projectsSlice";
import {editorRoles, WithUserPermission} from "../common/WithUserPermission";
import {faClone} from "@fortawesome/free-regular-svg-icons";
import Title from "antd/es/typography/Title";
import scenes from "../scene/Scenes";

const {confirm} = Modal
const ShotDetails = () => {

    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const {actId, projectId, storyId, chapterId, sceneId, shotId} = useParams()
    const shot = useAppSelector(state => state.shots.shot)
    const project = useAppSelector(state => state.projects.project)
    const status = useAppSelector(state => state.shots.status)
    const shots = useAppSelector(state => state.shots.shots)
    const newShot = useAppSelector(state => state.shots.newShot)
    const scenes = useAppSelector(state => state.scenes.scenes)
    const [modal, setModal] = React.useState(false)
    const index = shots.findIndex(shot => shot.id == shotId)

    useEffect(() => {
        if (newShot && projectId && sceneId) {
            dispatch(fetchShots({projectId: parseInt(projectId), sceneId: parseInt(sceneId)}))
            navigate(`/projects/${projectId}/stories/${storyId}/acts/${actId}/chapters/${chapterId}/scenes/${sceneId}/shots/${newShot}`)
        }
    }, [newShot]);

    useEffect(() => {
        if (projectId && shotId && (status == Status.Idle || shot?.id !== parseInt(shotId))) {
            dispatch(fetchShot({projectId: parseInt(projectId), shotId: parseInt(shotId)}))
            dispatch(fetchConfigNarration({projectId: parseInt(projectId)}))
            dispatch(fetchConfigChoice({projectId: parseInt(projectId)}))
        }
    }, [status, projectId, shotId, dispatch])

    const showDeleteConfirm = () => {
        confirm({
            title: 'Delete Shot',
            content: 'Are you sure you want to delete this shot?',
            icon: <></>,
            okText: 'Yes, delete',
            okButtonProps: {danger: true, type: 'primary'},
            cancelText: 'No',
            onOk() {
                if (!shotId || !projectId) return
                dispatch(deleteShot({projectId: parseInt(projectId), shotId: parseInt(shotId)}))
                navigate(`/projects/${projectId}/stories/${storyId}/acts/${actId}/chapters/${chapterId}/scenes/${sceneId}`)
            },
        });
    };

    return (
        <Fragment>
            <Flex justify={'space-between'}>
                <Space>
                    <Button type={'text'}
                            onClick={() => navigate(`/projects/${projectId}/stories/${storyId}/acts/${actId}/chapters/${chapterId}/scenes/${sceneId}`)}
                            icon={<FontAwesomeIcon icon={faAngleLeft}/>}/>
                    <Title level={4} style={{margin: 0}}>Shot {index > -1 ? (index + 1) : ""}</Title>
                </Space>
                <Space>
                    <Button type={'text'}
                            disabled={index <= 0}
                            onClick={() => {
                                if (shot) {
                                    if (index > 0) {
                                        navigate(`/projects/${projectId}/stories/${storyId}/acts/${actId}/chapters/${chapterId}/scenes/${sceneId}/shots/${shots[index - 1].id}`)
                                    }
                                }
                            }}
                            icon={<FontAwesomeIcon icon={faArrowLeft}/>}/>
                    <div>Switch Shot</div>
                    <Button type={'text'}
                            disabled={index >= shots.length - 1}
                            onClick={() => {
                                if (shot) {
                                    if (index < shots.length - 1) {
                                        navigate(`/projects/${projectId}/stories/${storyId}/acts/${actId}/chapters/${chapterId}/scenes/${sceneId}/shots/${shots[index + 1].id}`)
                                    }
                                }
                            }}
                            icon={<FontAwesomeIcon icon={faArrowRight}/>}/>
                </Space>

                <div>
                    <WithUserPermission roles={editorRoles}>
                        <Space>
                            <Tooltip title="Duplicate Shot">
                                <Button
                                    onClick={() => {
                                        if (project && sceneId) {
                                            if (shot && shot.id) {
                                                dispatch(duplicateShot({shotId: shot.id, projectId: project.id}))
                                            }
                                        }
                                    }}><FontAwesomeIcon icon={faClone}/></Button>
                            </Tooltip>
                            <Tooltip title="Delete Shot">
                                <Button onClick={() => showDeleteConfirm()}><FontAwesomeIcon icon={faTrash}/></Button>
                            </Tooltip>
                            <Tooltip title="Edit Shot">
                                <Button onClick={() => setModal(true)}
                                        icon={<FontAwesomeIcon icon={faPencil}/>}></Button>
                            </Tooltip>
                        </Space>
                    </WithUserPermission>
                </div>
            </Flex>
            <ShotEditor/>
            {shot ?
                <AddShotModal
                    shot={shot}
                    visible={modal}
                    onCancel={() => setModal(false)}
                    onSave={(shot: Shot) => {
                        if (project) {
                            dispatch(saveShot({projectId: project.id, shot: shot}))
                        }
                        setModal(false)
                    }}
                /> : ''}
        </Fragment>
    );
};

export default ShotDetails;